import { Component, ViewChild } from '@angular/core';
import { TransactionTableViewComponent } from '../transaction-table-view/transaction-table-view.component';
import { UIHelpers } from '../../../core/ui-helpers';
import { StorageService } from '../../../core/storage/storageService';
import { TableView } from '../../ui/filterable-table/tableView';
import { TransactionReportTableViewComponent } from '../transaction-report-table-view/transaction-report-table-view.component';

@Component({
  selector: 'app-monthly-transaction-summary',
  templateUrl: './monthly-transaction-summary.component.html',
  standalone: false,
})
export class MonthlyTransactionSummaryComponent {
  @ViewChild('transactionsSummaryTable') summaryTableControl:
    | TransactionTableViewComponent
    | undefined;

  summaryTableOptions: any = {
    filterable: false,
    paginated: false,
  };
  summaryTableView: any;

  constructor(
    public storage: StorageService,
    public uiHelper: UIHelpers,
  ) {
    if (storage.getCurrentUser() != undefined) {
      this.summaryTableOptions.userId = storage.getCurrentUser()?.id;
    }

    this.summaryTableView = new TableView(TransactionReportTableViewComponent);
  }

  ngAfterViewInit() {
    this.summaryTableControl?.setOptions(this.summaryTableOptions);
  }
}
